<template>
    <div ref="printable">
        <h2 class="d-none d-print-block">Terms and Conditions</h2>

        <p>
            <em>Effective date: December 30, 2019</em>
        </p>

        <p>
            Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the www.getmypaystub.com website and the GetMyPayStub App mobile application (together, or individually, the "Service") operated by Delta HCM LLC ("us", "we", or "our").
        </p>

        <p>
            Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who wish to access or use the Service.
        </p>

        <p>
            By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you do not have permission to access the Service.
        </p>

        <h3>Accounts</h3>
        <p>
            When you create an account with us, you guarantee that you are above the age of 18, and that the information you provide us is accurate, complete, and current at all times. Inaccurate, incomplete, or obsolete information may result in the immediate termination of your account on the Service.
        </p>
        <p>
            You are responsible for maintaining the confidentiality of your account and password, including but not limited to the restriction of access to your computer and/or account. You agree to accept responsibility for any and all activities or actions that occur under your account and/or password, whether your password is with our Service or a third-party service. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
        </p>

        <h3>Intellectual Property</h3>
        <p>
            The Service and its original content, features and functionality are and will remain the exclusive property of Delta HCM LLC and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Delta HCM LLC.
        </p>

        <h3>Electronic Signature and Record Disclosure</h3>
        <p>
            Your employer has retained getmypaystub.com ("us" or "we") to provide you with access to certain notices or disclosures that are required by law to be in writing. Described below are the terms and conditions for providing you with such notices and disclosures electronically through the getmypaystub.com online portal ("Portal").
        </p>
        <p>
            Unless you tell us otherwise in accordance with the procedures described herein, your employer will provide electronically to you through the Portal all required notices, disclosures, authorizations, acknowledgements, and other documents that are required to be provided or made available to you during the course of your employer's relationship with you. You may also be able to access these records after your relationship with your employer has ended. To reduce the chance of you inadvertently not receiving any notice or disclosure, we prefer to provide access to all of the required notices and disclosures to you by the same method and to the same email address that you have given us. If you do not agree with this process, please let us know as described below.
        </p>
        <p>
            You agree that documents accessible through the Portal may be electronically signed (hereafter referred to as "E-Signature"). You agree that the E-Signature appearing on any document in this Portal are the same as handwritten signatures for the purposes of validity, enforceability and admissibility. You also agree that no certification authority or other third-party verification is necessary to validate your E-Signature and that the lack of such certification or third-party verification will not in any way affect the enforceability of your E-Signature or any resulting contract, agreement, notice, disclosure, or employment form between you and your employer.
        </p>
        <p>
            You may withdraw your consent to receive electronic documents, notices or disclosures at any time. In order to withdraw consent, you must notify us via the Portal or otherwise in writing that you wish to withdraw and request that your future documents, notices and disclosures be provided in paper format. If you withdraw your consent, you will lose access to the Portal for records furnished by your current employer and any previous employer from whom you received documents, notices and disclosures through the Portal, and you will receive subsequent documents, notices and disclosures in paper format at no charge. This may increase the amount of time it takes to complete various transactions, eliminate the option to use the Portal for storing your records, and it may reduce the amount and timeliness of information you will receive.
        </p>
        <p>
            You must have hardware and software that is sufficient to access and use the Portal. The minimum hardware and software requirements are below. If your system does not meet the requirements, please withdraw your consent as provided herein.
        </p>

        <p>
            <i>Browsers:</i> latest release versions of Microsoft Edge, Google Chrome, Mozilla Firefox, or Apple Safari
            <br>
            <i>PDF Reader:</i> A .pdf file reader may be required to print and view pdf files.
            <br>
            <i>Security settings:</i> Configured to allow cookies
        </p>

        <p>
            By {clicking the I Agree box}, I confirm that:
        </p>

        <p>
            1. I can access and read this Electronic Signature and Record Disclosure; and
        </p>

        <p>
            2. I can print this document on paper or save and/or send this document to a place where I can print it, for future access and reference; and
        </p>

        <p>
            3. Until or unless I notify you as described above, I consent to receive exclusively through electronic means all notices, disclosures, authorizations, acknowledgements, and other documents that are required to be provided or made available to me by my employer in the course of our relationship.
        </p>

        <h3>Links To Other Web Sites</h3>
        <p>
            Our Service may contain links to third party web sites or services that are not owned or controlled by Delta HCM LLC
        </p>
        <p>
            Delta HCM LLC has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party web sites or services. We do not warrant the offerings of any of these entities/individuals or their websites.
        </p>
        <p>
            You acknowledge and agree that Delta HCM LLC shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party web sites or services.
        </p>
        <p>
            We strongly advise you to read the terms and conditions and privacy policies of any third party web sites or services that you visit.
        </p>

        <h3>Termination</h3>
        <p>
            We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.
        </p>
        <p>
            If you wish to terminate your account, you may simply discontinue using the Service.
        </p>
        <p>
            All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
        </p>

        <h3>Indemnification</h3>
        <p>
            You agree to defend, indemnify and hold harmless Delta HCM LLC and its licensee and licensors, and their employees, contractors, agents, officers and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Service, by you or any person using your account and password, or b) a breach of these Terms.
        </p>

        <h3>Limitation Of Liability</h3>
        <p>
            In no event shall Delta HCM LLC, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.
        </p>

        <h3>Disclaimer</h3>
        <p>
            Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
        </p>
        <p>
            Delta HCM LLC its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements.
        </p>

        <h3>Exclusions</h3>
        <p>
            Some jurisdictions do not allow the exclusion of certain warranties or the exclusion or limitation of liability for consequential or incidental damages, so the limitations above may not apply to you.
        </p>

        <h3>Governing Law</h3>
        <p>
            These Terms shall be governed and construed in accordance with the laws of Delaware, United States, without regard to its conflict of law provisions.
        </p>
        <p>
            Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.
        </p>

        <h3>Changes</h3>
        <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
        </p>
        <p>
            By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.
        </p>

        <h3>Contact Us</h3>
        <p>
            If you have any questions about these Terms, please contact us at <a href="mailto:info@getmypaystub.com">info@getmypaystub.com</a>
        </p>

    </div>
</template>

<script>
import PrintableMixin from '@/mixins/Printable'

export default {
    mixins: [PrintableMixin],
    data() {
        return {
            'printableItemType': 'terms-of-service',
            'printableItemId': null,
        }
    }
}
</script>
